module.exports = __webpack_public_path__ + "img/location.77fc8a25.png";